<template>
  <modal-ui :visible="visible" @close="closeModal" title="Додати посилання">
    <div
      class="drop-zone"
      @dragover.prevent
      @dragenter.prevent
      @dragenter="isDragging = true"
      @dragleave="isDragging = false"
      @drop.prevent="handleDrop"
      :style="
        isDragging
          ? 'border-color:#007BFF;'
          : iconsError.length > 0
          ? 'border-color: red;'
          : ''
      "
    >
      <v-col
        cols="8"
        v-if="socialLink.icon && socialLink.icon.path"
        class="text-center"
      >
        <img
          :src="socialLink.icon.path"
          width="50px"
          height="50px"
          style="object-fit: cover"
        />
        <p
          style="
            color: #a6a6ac;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            margin: 10px 0px;
          "
        >
          {{ socialLink.icon.name }}
        </p>
        <admin-submit-button height="38px" @click="triggerFileInput"
          >Змінити зображення</admin-submit-button
        >
        <v-col cols="12" class="text-center" v-if="iconError">
          <p style="color: red">{{ iconError }}</p>
        </v-col>
      </v-col>

      <v-col cols="12" class="text-center" v-else>
        <v-icon color="#838B94" size="40px">mdi-cloud-upload</v-icon>
        <p style="margin: 22px 0px">Перетягніть або завантажте SVG-іконку</p>
        <admin-submit-button height="38px" @click="triggerFileInput"
          >Виберіть іконку</admin-submit-button
        >
        <v-col cols="12" class="text-center" v-if="iconError">
          <p style="color: red">{{ iconError }}</p>
        </v-col>
      </v-col>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="icon/png, icon/jpeg, icon/svg"
      style="display: none"
      @change="handleFileSelect"
    />
    <p class="field-name" style="margin-top: 20px">Назва соціальної мережі</p>
    <v-text-field
      v-model="socialLink.name"
      outlined
      dense
      placeholder="Введіть назву соціальної мережі"
      @input="nameErrors = ''"
      :error-messages="nameError.length ? nameError : nameErrors"
      :hide-details="!nameErrors"
    />
    <p class="field-name" style="margin-top: 20px">Посилання</p>
    <v-text-field
      v-model="socialLink.link"
      outlined
      dense
      placeholder="Введіть посилання на соцмережу"
      @input="linkErrors = ''"
      :error-messages="linkError.length ? linkError : linkErrors"
      :hide-details="!linkErrors"
    />
    <v-row no-gutters style="margin-top: 22px">
      <admin-cancel-btn
        height="38px"
        @click="$emit('close')"
        width="calc(50% - 6px)"
        style="margin-right: 12px"
        >Скасувати</admin-cancel-btn
      >
      <admin-submit-button
        v-if="isEdit"
        :loading="isLoadingBtn"
        height="38px"
        width="calc(50% - 6px)"
        @click="updateSocialLink"
        >Зберегти</admin-submit-button
      >
      <admin-submit-button
        v-else
        :loading="isLoadingBtn"
        height="38px"
        width="calc(50% - 6px)"
        @click="createSocialLink"
        >Додати посилання</admin-submit-button
      >
    </v-row>
  </modal-ui>
</template>

<script>
import modalUi from "@/components/UI/Modals/modalUI.vue";
import AdminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import { validationMixin } from "vuelidate";
import AdminCancelBtn from "../../UI/Btns/adminCancelBtn.vue";
import { required } from "vuelidate/lib/validators";
import socialLinkService from "../../../requests/Admin/socialLinkService";
export default {
  mixins: [validationMixin],
  components: {
    modalUi,
    AdminSubmitButton,
    AdminCancelBtn,
  },
  data: () => ({
    allowedTypes: [
      "image/png",
      "image/jpeg",
      "image/svg",
      "image/svg+xmls",
      "image/svg+xml",
    ],
    maxSize: 1024 * 1024, // 1MB
    iconError: "",
    nameErrors: "",
    linkErrors: "",
    isDragging: false,
    isLoadingBtn: false,
    socialLink: {
      icon: null,
    },
  }),
  props: {
    visible: {
      default: false,
    },
    isEdit: {
      require: false,
    },
    itemForEdit: {
      require: false,
    },
  },
  validations: {
    socialLink: {
      icon: {
        required,
      },
      name: {
        required,
      },
      link: {
        required,
      },
    },
  },
  mounted() {
    if (this.isEdit) {
      this.socialLink = this.itemForEdit;
    }
  },
  methods: {
    async createSocialLink() {
      this.$v.socialLink.$touch();
      if (!this.$v.socialLink.$invalid && this.isValidUrl()) {
        this.isLoadingBtn = true;
        try {
          const form = new FormData();
          form.append("name", this.socialLink.name);
          form.append("link", this.socialLink.link);
          form.append("icon", this.socialLink.icon.file);

          await socialLinkService
            .createSocialLink(form)
            .then(() => {
              this.$emit("success", "Соціальну мережу додано");
              this.closeModal();
            })
            .catch((e) => {
              if (
                e.response?.data?.errors?.name?.[0] ==
                "The name has already been taken."
              ) {
                this.nameErrors = "Така назва соціальної мережі вже існує";
              }
              console.log("ERROR", e);
            });
        } catch (e) {
          console.error("server error", e);
        } finally {
          this.isLoadingBtn = false;
        }
      }
    },
    async updateSocialLink() {
      this.$v.socialLink.$touch();
      if (!this.$v.socialLink.$invalid && this.isValidUrl()) {
        this.isLoadingBtn = true;
        try {
          const form = new FormData();
          form.append("name", this.socialLink.name);
          form.append("link", this.socialLink.link);
          form.append("icon", this.socialLink.icon.file);
          await socialLinkService
            .updateSocialLink(this.socialLink.id, form)
            .then(() => {
              this.$emit("success", "Соціальну мережу оновлено");
              this.closeModal();
            });
        } catch (e) {
          console.error(e);
        } finally {
          this.isLoadingBtn = false;
        }
      }
    },
    isValidUrl() {
      try {
        new URL(this.socialLink.link);
        console.log("WORK TRUE");
        return true;
      } catch (_) {
        this.linkErrors = "Не правильне посилання";
        return false;
      }
    },
    closeModal() {
      this.$emit("close");
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    addFiles(newFile) {
      this.iconError = "";
      const file = newFile && newFile[0];
      if (!file) return;
      console.log("FILE", file.type);
      if (!this.allowedTypes.includes(file.type)) {
        this.iconError =
          "Невірний формат файлу. Дозволені формати: PNG, SVG або JPG.";
        return false;
      }

      if (file.size > this.maxSize) {
        this.iconError = `Файл ${file.name} перевищує 1MB`;
        return false;
      }

      this.$set(this.socialLink, "icon", {
        id: Date.now(),
        path: URL.createObjectURL(file),
        name: file.name,
        file,
      });
      this.isDragging = false;
      this.iconError = "";
    },

    deleteImage() {
      this.socialLink.icon = null;
    },

    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      const droppedFiles = event.dataTransfer.files;
      this.addFiles(droppedFiles);
    },

    handleFileSelect(event) {
      const selectedFiles = event.target.files;
      this.addFiles(selectedFiles);
    },
  },
  computed: {
    iconsError() {
      const errors = [];
      if (this.$v.socialLink.icon.$dirty && !this.$v.socialLink.icon.required) {
        errors.push("");
      }
      return errors;
    },
    nameError() {
      const errors = [];
      if (this.$v.socialLink.name.$dirty && !this.$v.socialLink.name.required) {
        errors.push("");
      }
      return errors;
    },

    linkError() {
      const errors = [];
      if (this.$v.socialLink.link.$dirty && !this.$v.socialLink.link.required) {
        errors.push("");
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.drop-zone {
  width: 100%;
  height: 295px;
  border-radius: 4px;
  border: 1px dashed #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 26px;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>